<template>
  <div class="hm-tab-management">
    <el-card>
      <div class="panel flex item-center flex-between mb20">
        <div class="button-wrapper">
          <el-button size="small" type="primary" @click="newTag"
            >新增券墙分类</el-button
          >
        </div>
        <div class="form-wrapper flex">
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="输入券墙分类名称"
            v-model.trim="keywords"
            style="width: 150px"
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table :data="tabList" border>
          <el-table-column
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            prop="labelName"
            label="券墙分类名称"
          ></el-table-column>
          <el-table-column
            prop="labelInfo"
            label="券墙分类描述"
          ></el-table-column>
          <el-table-column
            prop="creatTimeFormat"
            label="操作日期"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" @click="edit(scope.row)" type="text"
                >编辑</el-button
              >
              <el-button size="small" @click="remove(scope.row)" type="text"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="table-footer text-center">
          <el-pagination
            background
            layout="total,sizes,  prev, pager, next, jumper"
            :total="tabListTotal"
            @current-change="paging"
            :current-page="currentPage"
            :page-size="pageSize"
          ></el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog title="新增券墙分类" :visible.sync="dialogvisible" width="800px">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="80px"
      >
        <el-form-item label="券墙分类" prop="labelName" :error="labelNameError">
          <el-input
            v-model.trim="ruleForm.labelName"
            placeholder="请输入券墙分类名称"
            size="small"
            style="width: 200px"
          ></el-input>
          <span class="tip">注：名称在10字符内</span>
        </el-form-item>
        <el-form-item label="排序" prop="seqNum">
          <el-input
            @input="filterGt0OrFixed0('seqNum')"
            v-model.trim="ruleForm.seqNum"
            placeholder="请输入数字"
            size="small"
            style="width: 200px"
          ></el-input>
          <span class="tip"
            >注：不填默认99，这个控制的是在手机端领券中心里券墙的显示顺序</span
          >
        </el-form-item>
        <!-- <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            format="yyyy-MM-dd HH:mm:ss"
            default-time="00:00:00"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="startTimeChange"
            v-model="ruleForm.startTime"
            type="datetime"
            placeholder="请选择开始时间"
            style="width: 200px"
            size="small"
            key="startTime"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <span class="tip"
            >注：控制的是手机端领券中心里该券墙开始显示的时间</span
          >
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            :disabled="ruleForm.startTime === ''"
            format="yyyy-MM-dd HH:mm:ss"
            default-time="23:59:59"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.endTime"
            type="datetime"
            placeholder="请选择结束时间"
            style="width: 200px"
            size="small"
            key="endTime"
            :picker-options="pickerOptionsEnd"
          >
          </el-date-picker>
          <span class="tip"
            >注：控制的是手机端领券中心里该券墙开始显示的时间</span
          >
        </el-form-item> -->
        <el-form-item label="描述" prop="labelInfo">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入券墙分类描述"
            v-model="ruleForm.labelInfo"
            style="width: 200px"
          ></el-input>
          <span class="tip">注：描述在200字符内</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button type="primary" @click="addTag('ruleForm')" size="small"
          >保 存</el-button
        >
        <el-button @click="dialogvisible = false" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptionsEnd: this.beginDate(),
      dialogvisible: false,
      labelName: "",
      labelInfo: "",
      pageSize: 10,
      currentPage: 1,
      mode: "",
      couponLabelId: "",
      keywords: "",
      type: "",
      labelNameError: "",
      ruleForm: {
        labelName: "",
        seqNum: "",
        // startTime: "",
        // endTime: "",
        labelInfo: ""
      },
      rules: {
        labelName: [
          { required: true, message: "请输入券墙分类名称", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度需要在 1 到 10 个字符",
            trigger: "blur"
          }
        ],
        startTime: {
          required: true,
          message: "请选择开始时间",
          trigger: "blur"
        }
      }
    };
  },
  created() {
    // this.getParamsCookie();
    this.queryList();
  },
  computed: mapState({
    tabList: state => state.rules.tabList,
    saveTabCode: state => state.rules.saveTabCode,
    modifyTabCode: state => state.rules.modifyTabCode,
    removeTabCode: state => state.rules.removeTabCode,
    tabListTotal: state => state.rules.tabListTotal,
    isValidTab: state => state.rules.isValidTab
  }),
  watch: {
    dialogvisible(val) {
      if (!val) {
        this.ruleForm.labelName = "";
        this.ruleForm.labelInfo = "";
      }
    },
    saveTabCode(val) {
      if (val === 0) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.reset();
        this.$store.dispatch("queryTab", {
          type: "back"
        });
      }
      this.$store.commit("saveTab", "");
    },
    modifyTabCode(val) {
      if (val === 0) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.reset();
        this.$store.dispatch("queryTab", {
          type: "back"
        });
      }
      this.$store.commit("modifyTab", "");
    },
    removeTabCode(val) {
      if (val === 0) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.reset();
        this.$store.dispatch("queryTab", {
          type: "back"
        });
      }
      this.$store.commit("removeTab", {});
    }
  },
  methods: {
    startTimeChange() {
      this.ruleForm.endTime = "";
    },
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.ruleForm.startTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.ruleForm.startTime).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    reset() {
      this.dialogvisible = false;
      this.ruleForm.labelName = "";
      this.ruleForm.labelInfo = "";
      this.currentPage = 1;
    },
    newTag() {
      this.dialogvisible = true;
      this.mode = "new";
    },
    addTag() {
      this.submitRequest();
    },
    submitRequest() {
      this.$refs.ruleForm.validate(valid => {
        if (valid && this.labelNameError === "") {
          if (this.mode === "new") {
            this.$store.dispatch("saveTab", {
              labelName: this.ruleForm.labelName,
              labelInfo: this.ruleForm.labelInfo,
              seqNum: this.ruleForm.seqNum
            });
          } else if (this.mode === "edit") {
            this.$store.dispatch("modifyTab", {
              labelName: this.ruleForm.labelName,
              labelInfo: this.ruleForm.labelInfo,
              couponLabelId: this.couponLabelId,
              seqNum: this.ruleForm.seqNum
            });
          }
        }
      });
      this.type = "";
    },
    edit(row) {
      this.dialogvisible = true;
      this.ruleForm.labelInfo = row.labelInfo;
      this.ruleForm.labelName = row.labelName;
      this.ruleForm.seqNum = row.seqNum || "";
      this.couponLabelId = row.couponLabelId;
      this.mode = "edit";
    },
    remove(row) {
      this.$confirm(
        `
        <div class="message">
          <div>确认将<strong style="color: #f56c6c">${
            row.labelName
          }</strong>删除？</div>
        </div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.$store.dispatch("modifyTab", {
            couponLabelId: row.couponLabelId,
            status: 1,
            delFlag: "1"
          });
        })
        .catch(() => {});
    },
    setParamsCookie() {
      let searchCondition = {
        keywords: this.keywords
      };
      setCookie({
        key: "tabManagementParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "tabManagementParams", type: "session" });
      if (prams) {
        this.keywords = prams.keywords;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryList() {
      // this.setParamsCookie();
      this.$store.dispatch("queryTab", {
        labelName: this.keywords,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: "back"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    checkCouponNameValid() {
      const labelName = this.ruleForm.labelName;
      if (labelName !== "") {
        this.labelNameError = "";
        this.$store.dispatch("checkTabValid", {
          labelName
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.table-footer {
  margin-top: 10px;
}
.tip {
  color: #999;
  margin-left: 10px;
  font-size: 0.8rem;
}
</style>
